"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M4.5156 9.7234C4.2556 9.7905 4 9.6023 4 9.3436c0-.1559.096-.297.2445-.36l7.2438-3.0624.0021-.0001 6.9912 1.9727a3.119 3.119 0 0 0 1.6579.0092L22 7.4004V5.405l-2.402.6488a1.0396 1.0396 0 0 1-.5526-.003L12.0541 4.078a2.0794 2.0794 0 0 0-1.3715.085L3.4387 7.2255C2.5645 7.5952 2 8.4261 2 9.3436c0 1.5222 1.5036 2.6298 3.0342 2.2351l3.0686-.7913c.3195.8275 1.1118 1.4254 2.0566 1.5037l5.7939.6709a3.1137 3.1137 0 0 0 1.6518-.1886l2.401-.9729a1.038 1.038 0 0 1 .7551-.0087L22 12.2603v-2.0645l-.5061-.1914a3.1145 3.1145 0 0 0-2.2652.0262l-2.401.9729a1.038 1.038 0 0 1-.5506.0629l-5.9456-.6891c-.1919-.0159-.3472-.1565-.3751-.3395-.0367-.2407.1575-.4566.4108-.4566h4.2123v-1.921h-4.2123c-.8682 0-1.6172.4362-2.0422 1.081l-3.8094.9822zM6 16l-4 2.25 4 2.25v-1.25h12v1.25l4-2.25L18 16v1.25H6V16z"
  })];
};

exports.default = _default;